import React from 'react';
import cn from 'classnames';

import DropdownMenu from 'Components/Admin/DropdownMenu';
import ActionMenu from '../ActionMenu/ActionMenu';

const ActionDropdown = ({ menuItems, title, id = 0, className }) => {
  const btnTrigger = (
    <span className="action_menu__trigger" data-testid={`action-menu-btn-${id}`}>
      <svg width="4" height="16" viewBox="0 0 4 16" className="action_menu__icon" xmlns="http://www.w3.org/2000/svg">
        <circle cx="2" cy="2" r="2" />
        <circle cx="2" cy="8" r="2" />
        <circle cx="2" cy="14" r="2" />
      </svg>
    </span>
  );

  return (
    <div className={cn('action-dropdown', className)}>
      <DropdownMenu
        triggerButtonRender={() => btnTrigger}
        binding="top"
      >
        <ActionMenu title={title} menuItems={menuItems} />
      </DropdownMenu>
    </div>
  );
};

export default ActionDropdown;
